import {
  Mutation,
  StartRdcSuccess,
  Typenames,
} from '@varo/graphql-schema-types';
import StartRDC from 'services/graphql/mutations/StartRDC';
import { Maybe } from 'shared/utils/types';
import { CombinedError, useMutation } from 'urql';

interface UpdateSelectedAccount {
  loading: boolean;
  updateAccount: (id: string) => void;
  error?: Maybe<CombinedError>;
  updatedSessionID: Maybe<string>;
}

function formatSessionID(data: Maybe<Mutation>): Maybe<string> {
  if (data) {
    const { startRdc } = data;
    if (startRdc.__typename === Typenames.StartRdcSuccess) {
      return (startRdc as StartRdcSuccess).session;
    }
  }
  return null;
}
//Mutation that intakes a account id from an IInternalBankingAccount and uses that string to retrieve a session ID for the current Check deposit session
export const useUpdateSelectedAccount = (): UpdateSelectedAccount => {
  const [{ fetching, data, error }, startSession] =
    useMutation<Mutation>(StartRDC);

  const handleUpdatedAccount = (id: string) => {
    const input = { accountId: id };
    void startSession({ input });
  };

  return {
    loading: fetching,
    updateAccount: handleUpdatedAccount,
    error: error ?? null,
    updatedSessionID: formatSessionID(data ?? null),
  };
};
